const React = require('react');
const PropTypes = require('prop-types');
const { MobileDetection } = require('@reverbdotcom/discovery-ui');
const AjaxMultiAddToCartButton =
  require('components/listings/cart/ajax_multi_add_to_cart_button');

class AutoProductBundle extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      errorMessage: null,
    };

    this.handleAddToCartError = this.handleAddToCartError.bind(this);
  }

  get listing() {
    return this.props.bundle.discounted_listing;
  }

  get image() {
    const links = this.listing.photos[0]._links;

    if (MobileDetection.isMobileBrowser()) {
      return links.mobile_small.href;
    }

    return links.medium_square.href;
  }

  get productIds() {
    return [
      this.props.mainListing.id,
      this.listing.id,
    ];
  }

  handleAddToCartError(errorMessage) {
    this.setState({ errorMessage });
  }

  renderError() {
    if (!this.state.errorMessage) { return null; }

    return <div className="bundle-item__error alert alert-error">{this.state.errorMessage}</div>;
  }

  render() {
    return (
      <div className="bundle-item">
        <div className="bundle-item__image-group">
          <div className="bundle-item__image-group__image">
            <img
              alt={this.props.mainListing.title}
              src={this.props.mainListing.photos[0]._links.medium_square.href}
            />
            <div className="bundle-item__price">
              {this.props.mainListing.price.display}
            </div>
          </div>
          <div className="bundle-item__image-group__plus">
            +
          </div>
          <div className="bundle-item__image-group__image bundle-item__image-group__image--linked">
            <a href={this.listing._links.web.href}>
              <img alt={this.listing.title} src={this.image} />
              <div className="bundle-item__price">
                <span className="bundle-item__price__strike">
                  {this.listing.price.display}
                </span>
                <span className="bundle-item__price__discounted">
                  {this.props.bundle.discounted_price.display}
                </span>
              </div>
            </a>
          </div>
        </div>
        <div className="bundle-item__details">
          <h4 className="bundle-item__details__title">
            {this.listing.title}
          </h4>
          <p className="bundle-item__details__total">
            {I18n.t('js.autoProductBundles.total', { totalPrice: this.props.bundle.total_bundle_price.display })}
          </p>
          <AjaxMultiAddToCartButton
            productIds={this.productIds}
            text={I18n.t('js.autoProductBundles.addBothToCart')}
            className="bundle-item__details__add-to-cart"
            onError={this.handleAddToCartError}
          />
        </div>
        {this.renderError()}
      </div>
    );
  }
}

AutoProductBundle.propTypes = {
  bundle: PropTypes.object.isRequired,
  mainListing: PropTypes.object.isRequired,
};

module.exports = AutoProductBundle;



// WEBPACK FOOTER //
// ./javascripts/components/product_show_page/auto_product_bundle.jsx